export default __webpack_public_path__ + "static/media/PrimaryColorArrow.103b21e6.svg";